module.exports = __webpack_public_path__ + "img/education.8f5dcafa.jpg";